/**
 * Unified Dashboard Navigation Items Configuration
 *
 * IMPORTANT for Kid items: Must stay in sync with the Ruby helper in
 * app/helpers/children_helper.rb (KID_NAV_ITEMS constant)
 *
 * When adding/removing/modifying navigation items:
 * 1. For kids: Update KID_NAV_ITEMS in app/helpers/children_helper.rb
 * 2. Update the items below to match
 * 3. Add translations to both:
 *    - config/locales/children.{en,vi}.yml (for ERB)
 *    - react/shared/i18n/locales/{en,vi}.json (for React)
 */

export const KID_NAV_ITEMS = [
  {
    key: 'dashboard',
    path: '/',
    translationKey: 'children.dashboard.sidebar.dashboard',
    isReactRoute: true
  },
  {
    key: 'progress',
    path: '/progress',
    translationKey: 'children.dashboard.sidebar.progress',
    isReactRoute: true
  },
  {
    key: 'wallet',
    path: '/wallet',
    translationKey: 'children.dashboard.sidebar.wallet',
    isReactRoute: true
  },
  {
    key: 'monitored_activities',
    path: '/monitored-activities',
    translationKey: 'children.dashboard.sidebar.monitored_activities',
    isReactRoute: true
  },
  {
    key: 'profile',
    path: '/profile',
    translationKey: 'children.dashboard.sidebar.profile',
    isReactRoute: true
  }
];

export const GUARDIAN_NAV_ITEMS = [
  {
    key: 'dashboard',
    path: '/',
    translationKey: 'guardian.sidebar.dashboard',
    isReactRoute: true
  },
  {
    key: 'add_child',
    path: '/children/new',
    translationKey: 'guardian.sidebar.add_child',
    isReactRoute: true
  },
  {
    key: 'guardians',
    path: '/guardians',
    translationKey: 'guardian.sidebar.guardians',
    isReactRoute: true
  },
  {
    key: 'family_currencies',
    path: '/family-currencies',
    translationKey: 'guardian.sidebar.family_currencies',
    isReactRoute: true
  },
  {
    key: 'monitored_sessions',
    path: '/monitored-sessions',
    translationKey: 'guardian.sidebar.monitored_sessions',
    isReactRoute: true
  },
  {
    key: 'referrals',
    path: '/referrals',
    translationKey: 'guardian.sidebar.referrals',
    isReactRoute: true
  }
];

/**
 * Get navigation items based on dashboard mode
 * @param {string} mode - 'kid' or 'guardian'
 * @returns {Array} Navigation items for the specified mode
 */
export const getNavItems = (mode) => {
  return mode === 'kid' ? KID_NAV_ITEMS : GUARDIAN_NAV_ITEMS;
};

export default { KID_NAV_ITEMS, GUARDIAN_NAV_ITEMS, getNavItems };
